export default __webpack_public_path__ + "static/media/bg-invert.ffb177b3.png";